import React, { Component } from 'react';
import { Modal, Spin, message, Input, Popover, Button } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input;

class InformModify extends Component {
    state = {
        record: {},
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            params: {},
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { record: { hourId, hourType } } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.queryManHourNoticeMemory,
            data: {
                hourId,
                hourType,
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                params.modifyContent = res.success ? res.success.content : '';
                this.setState({ params, loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }
    
    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { record, params } = this.state;
        const { yearNum, monthNum } = record;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.createManHourNoticeModify,
            data: {
                dateValue: `${yearNum}-${monthNum}`,
                ...record,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params: { modifyContent } } = this.state;
        return (
            <Modal
                title="通知修改"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                confirmLoading={loading}
                maskClosable={false}
                width={600}
            >
                <Spin spinning={loading}>
                    <div style={{ padding: '30px 40px' }}>
                        修改说明：<TextArea rows={6} value={modifyContent} onChange={e => this.handleChange(e, 'modifyContent')} style={{ width: "500px", verticalAlign: "top" }} />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

class Detail extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    };

    show = record => {
        this.setState({
            record,
            data: [],
            visible: true,
            pagination: {
                current: 1,
                pageSize: 5,
            },
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { record, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { hourId, hourType } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryManHourDetail,
            data: {
                offset: current,
                limit: pageSize,
                hourId,
                hourType,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '工作日期',
        dataIndex: 'manHourDate',
        key: 'manHourDate',
        width: 100,
        render: text => text ? text.slice(0, 10) : '',
    }, {
        title: '工作类型',
        dataIndex: 'enterpriseWorkTypeName',
        key: 'enterpriseWorkTypeName',
        width: 200,
    }, {
        title: '工作内容（编号）',
        dataIndex: 'enterpriseWorkTypeString',
        key: 'enterpriseWorkTypeString',
    }, {
        title: '用时',
        dataIndex: 'totalShow',
        key: 'totalShow',
        width: 100,
        render: (text, record) => {
            const obj = { children: text };
            if (record.manHourVisitTip) {
                const list = record.manHourVisitTip.split(';');
                const node = list.map(item => <div>{item}</div>);
                obj.children = <Popover placement="bottomRight" overlayClassName="gray-pop" content={node}>
                                    <div>
                                        <i className='pop'></i>
                                        {text}
                                    </div>
                                </Popover>
            }
            return obj;
        },
    }, {
        title: '备注',
        dataIndex: 'remarks',
        key: 'remarks',
        width: 100,

    }]

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, visible, loading, pagination, record } = this.state;
        const { yearNum, monthNum, userCompellation, employeeCode, investigationName, investigationCode, investigationSiteName, investigationSiteCode, roleCode } = record;
        return (
            <Modal
                title="明细记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
                maskClosable={false}
                width="720px"
            >
                <Spin spinning={loading}>
                    <div style={{ padding:'10px 20px' }}>
                        <div style={{ marginBottom: 10 }}>
                            时间：{`${yearNum}-${monthNum}`}
                            <span className="ant-divider" />
                            录入者 ：{`${userCompellation}(${employeeCode})`}
                            <span className="ant-divider" />
                            临床项目 ：{investigationName}({investigationCode})
                            <span className="ant-divider" />
                            中心 ：{`${investigationSiteName}(${investigationSiteCode})`}
                            <span className="ant-divider" />
                            角色 : {roleCode}
                        </div>
                        <TableC
                            data={data}
                            scrollY={220}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export { InformModify, Detail };


// WEBPACK FOOTER //
// ./src/components/manHour/confirmManhour/Widget.js